export {
  default as Address,
  buildAddressFromComponents,
  addressAsString,
} from './Address';
export type { ILocalAddress } from './Address';
